import {useTranslation} from "react-i18next";
// -
import IconBool from "components/IconBool";
import DurationDisplay from "components/datestimes/DurationDisplay";
import OrderByHeaders from "components/ordering/OrderByHeaders";

// Umbral de un C si su check está marcado en la plantilla; "-" si no
const threshold = (active, value) => (active ? `${value}%` : "-");

const MainTableTemplates = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tags");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length === 0;
        buttons.duplicate.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyTitleStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };
    const stickyHeaderStyle = {
        position: "sticky",
        top: "200px",
        backgroundColor: "white",
    };
    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="sticky-top" colSpan="8" style={{border: "none", ...stickyTitleStyle}}></th>
                    <th
                        className="sticky-top border-bottom-sticky"
                        colSpan="5"
                        style={{textAlign: "center", ...stickyTitleStyle}}>
                        {_Tt("common.byDefault")}
                    </th>
                    <th className="sticky-top" style={{border: "none", ...stickyTitleStyle}}></th>
                </tr>
                <tr>
                    <th className="sticky-top border-bottom-sticky" style={{width: "26px", ...stickyHeaderStyle}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick} className="cursor-pointer">
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>{item.origin}</td>
                        <td>{item.destination}</td>
                        <td>{_Tc("wastes." + item.waste_type)}</td>
                        <td>{_Tc("downloads." + item.download_type)}</td>
                        <td className="text-center">{item.actives}</td>
                        <td className="text-center">{threshold(item.c1, item.risk_threshold)}</td>
                        <td className="text-center">{threshold(item.c2, item.target_threshold)}</td>
                        <td className="text-center">{threshold(item.c3, item.tomorrow_threshold)}</td>
                        <td className="text-center">{item.days || "-"}</td>
                        <td className="text-center">
                            <IconBool value={item.force} />
                        </td>
                        <td className="text-end">
                            <DurationDisplay seconds={item.duration} format="HH:mm" />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default MainTableTemplates;
